import { buildCommonFilters, embedFilter, labeledMapItem } from '../sharedFilters'

const DATASET_KEY = 'dmp_logs'

// Same broken units branch as dmp_alarms (500 server-side), so installation,
// estado and municipio are not offered; sectors/centers join directly off
// dmp_panels and do work. type_alarms resolves null on every log
// (dmp_logs.id_type_alarm is not populated), so no alarm-type field here —
// the log's own status is is_recovered.
const commonFilters = buildCommonFilters(DATASET_KEY, {
  INSTALLATION: false,                           // units branch: 500 server-side
  REGION: false,                                 // units branch: 500 server-side
  MUNICIPALITY: false,                           // units branch: 500 server-side
  SECTOR: {},                                    // sectors.name (via dmp_panels.id_sector)
  CENTER: {},                                    // centers.name (via dmp_panels.id_center)
  TENANT: {},                                    // tenants.name (via dmp_servers.id_tenant)
  STATUS: false,                                 // the alarm branch belongs to dmp_alarms
  USER: false,                                   // no users join
})

const IS_RECOVERED_LABELS = { 0: 'No', 1: 'Sí' }
const IS_RECOVERED_MAPPING = JSON.stringify({
  'dmp_logs.is_recovered': IS_RECOVERED_LABELS,
  is_recovered: IS_RECOVERED_LABELS,
})

export default {
  key: DATASET_KEY,
  label: 'Logs DMP',
  timeColumn: 'dmp_logs.event_created_at',
  permission: { action: 'read', subject: 'Dmp' },

  tables: {
    dmp_logs: ["id", "event_id", "event_definition", "event_type", "device_type", "device_id", "device_name", "area_id", "area_name", "user_id", "user_name", "description", "event_created_at", "id_alarm", "id_dmp_panel", "id_type_alarm", "is_recovered", "created_at", "updated_at"],
    dmp_panels: ["id", "name", "id_sector", "id_center", "id_dmp_server"],
    dmp_servers: ["id", "name", "id_tenant"],
    sectors: ["id", "id_center", "name"],
    centers: ["id", "name"],
    tenants: ["id", "name"],
  },

  views: [
    { value: 'bar', label: 'Barras' },
    { value: 'dona', label: 'Dona' },
    { value: 'ring', label: 'Pastel' },
    { value: 'dataframe', label: 'Lista', adminOnly: true },
    { value: 'timeseries', label: 'Tendencia' },
    { value: 'json', label: 'JSON', adminOnly: true },
  ],

  defaults: {
    field: 'dmp_logs.device_name',
  },

  csvConfig: {
    columns: 'dmp_logs.event_created_at,dmp_logs.event_definition,dmp_logs.event_type,dmp_logs.device_type,dmp_logs.device_id,dmp_logs.device_name,dmp_logs.area_name,dmp_logs.user_name,dmp_logs.description,dmp_logs.is_recovered,dmp_panels.name,sectors.name,centers.name',
    qualifiedColumns: true,
  },

  viewDefaults: {
    csv: { limit: -1 },
    dataframe: { limit: -1 },
    json: { limit: -1 },
    bar: { stack: 'group' },
  },

  fields: [
    { key: 'dmp_logs.device_name', label: 'Dispositivo' },
    { key: 'dmp_logs.device_type', label: 'Tipo de dispositivo' },
    { key: 'dmp_logs.event_type', label: 'Tipo de evento' },
    { key: 'dmp_logs.is_recovered', label: 'Recuperado', defaultParams: { mapping: IS_RECOVERED_MAPPING } },
    { key: 'dmp_panels.name', label: 'Panel' },
    { key: 'sectors.name', label: 'Región' },
    { key: 'centers.name', label: 'Centro' },
    { key: 'dmp_logs.event_created_at', label: 'Fecha del evento', defaultParams: { freq: '1mo' } },
  ],

  filters: [
    ...commonFilters,
    embedFilter(DATASET_KEY, 'dmp_logs.device_name', 'Dispositivo', 'name'),
    embedFilter(DATASET_KEY, 'dmp_logs.device_type', 'Tipo de dispositivo', 'device_type'),
    // event_definition / event_type are the raw DMP codes (Za, Zr… / BU, SV…),
    // the same values the /#/dmp/logs view filters by.
    embedFilter(DATASET_KEY, 'dmp_logs.event_type', 'Tipo de evento', 'event_type'),
    embedFilter(DATASET_KEY, 'dmp_logs.event_definition', 'Definición de evento', 'event_definition'),
    embedFilter(DATASET_KEY, 'dmp_logs.area_name', 'Área', 'area'),
    embedFilter(DATASET_KEY, 'dmp_logs.is_recovered', 'Recuperado', 'is_recovered', {
      optionsOverrides: { mapItem: labeledMapItem(IS_RECOVERED_LABELS) },
    }),
    embedFilter(DATASET_KEY, 'dmp_panels.name', 'Panel', 'group'),
  ],

  dateGrouping: {
    column: 'dmp_logs.event_created_at',
    presets: [
      { value: '1d', label: 'Día' },
      { value: '1W', label: 'Semana' },
      { value: '1M', label: 'Mes' },
      { value: '1Y', label: 'Año' },
    ],
  },
}
